// source: witbooking/backoffice/orchestrator/globalactions/v1/global_actions_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb = require('../../../../../witbooking/backoffice/orchestrator/common/v1/orchestration_criteria_pb.js');
goog.object.extend(proto, witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.displayName = 'proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    config: (f = msg.getConfig()) && proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional GlobalActionsConfig config = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.prototype.getConfig = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configsList: jspb.Message.toObjectList(msg.getConfigsList(),
    proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader);
      msg.addConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GlobalActionsConfig configs = 1;
 * @return {!Array<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig>}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.prototype.getConfigsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig>} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.prototype.setConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.prototype.addConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.prototype.clearConfigsList = function() {
  return this.setConfigsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    config: (f = msg.getConfig()) && proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GlobalActionsConfig config = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.getConfig = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    config: (f = msg.getConfig()) && proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional GlobalActionsConfig config = 1;
 * @return {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.prototype.getConfig = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse} returns this
*/
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    config: (f = msg.getConfig()) && proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig;
      reader.readMessage(value,proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GlobalActionsConfig config = 2;
 * @return {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.getConfig = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig, 2));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} returns this
*/
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    after: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAfter();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string after = 3;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.getAfter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest.prototype.setAfter = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    actionsMap: (f = msg.getActionsMap()) ? f.toObject(includeInstance, undefined) : [],
    criteria: (f = msg.getCriteria()) && witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig;
  return proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = msg.getActionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 5:
      var value = new witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria;
      reader.readMessage(value,witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria.deserializeBinaryFromReader);
      msg.setCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCriteria();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> actions = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.getActionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.clearActionsMap = function() {
  this.getActionsMap().clear();
  return this;};


/**
 * optional witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria criteria = 5;
 * @return {?proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.getCriteria = function() {
  return /** @type{?proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria} */ (
    jspb.Message.getWrapperField(this, witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb.OrchestrationCriteria, 5));
};


/**
 * @param {?proto.witbooking.backoffice.orchestrator.common.v1.OrchestrationCriteria|undefined} value
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} returns this
*/
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.setCriteria = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig} returns this
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.clearCriteria = function() {
  return this.setCriteria(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsConfig.prototype.hasCriteria = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.witbooking.backoffice.orchestrator.globalactions.v1);
